// Opt-in local design preview; never enabled by a production build.
export const catalogPreview = import.meta.env.DEV &&
  import.meta.env.VITE_LOCAL_CATALOG_PREVIEW === 'true' &&
  ['shop.banjinos.dev', 'dtc.banjinos.dev', 'localhost', '127.0.0.1'].includes(window.location.hostname)
